export type FeedbackSurveyMode = "csat" | "nps";

export type FeedbackSurveyCancelDetail = {
  feedbackType: FeedbackSurveyMode;
};

export type FeedbackSurveyCloseDetail = {
  feedbackType: FeedbackSurveyMode;
};

export type FeedbackSurveySkipDetail = {
  // `skip` only ever fires for CSAT surveys; NPS dismissals fire `cancel`.
  feedbackType: "csat";
};

export type FeedbackSurveySubmitDetail = {
  feedback: string;
  feedbackType: FeedbackSurveyMode;
  rating?: number;
};

export interface CsatRating {
  emoji: string;
  label: string;
  value: number;
}

export const NPS_SCORES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const CSAT_RATINGS: CsatRating[] = [
  { emoji: "😩", label: "Bad", value: 1 },
  { emoji: "🙁", label: "Poor", value: 2 },
  { emoji: "😐", label: "OK", value: 3 },
  { emoji: "🙂", label: "Good", value: 4 },
  { emoji: "😀", label: "Great", value: 5 },
];
